import { useState } from 'react';
import { useGeneratePdfFromHtml } from 'queries/editor/useGeneratePdfFromHtml';

export function useHandlePdfAddAttachment(
  onPdfAddAttachment?: (file: File) => Promise<void>,
) {
  const [isLoading, setIsLoading] = useState(false);
  const pdfGeneration = useGeneratePdfFromHtml();

  async function handlePdfAddAttachment(html: string) {
    if (!onPdfAddAttachment) return;

    setIsLoading(true);
    try {
      const { pdfUrl, filename } = await pdfGeneration.generate({ html });

      if (pdfUrl && filename) {
        const pdfBlob = await fetch(pdfUrl).then(res => res.blob());
        const file = new File([pdfBlob], filename, {
          type: 'application/pdf',
        });
        await onPdfAddAttachment(file);
      }
    } finally {
      setIsLoading(false);
    }
  }

  return {
    handlePdfAddAttachment,
    isLoading,
  };
}
